var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["product-reviews-response-icon.j2"] = require( "product-reviews-response-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-response.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "review")),"ClientResponses")),"length") > 0) {
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "review")),"ClientResponses")),0);
frame.set("response", t_1, true);
if(frame.topLevel) {
context.setVariable("response", t_1);
}
if(frame.topLevel) {
context.addExport("response", t_1);
}
output += "\n\n    <div class=\"c-product-review__response\">\n\n        <div class=\"c-product-review__response--icon\">\n            ";
env.getTemplate("product-reviews-response-icon.j2", false, "product/templates/product-reviews-response.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n        </div>\n            \n        <p class=\"c-product-review__response--brand\">\n            ";
output += runtime.suppressValue((lineno = 10, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-reviews-response_opening",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core"),"params": [(lineno = 10, colno = 78, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-reviews-response_brand-name"]))]})])), env.opts.autoescape);
output += "\n        </p>\n\n        <p class=\"c-product-review__response--message\">\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "response")),"Response"), env.opts.autoescape);
output += "\n        </p>\n\n    </div>";
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-response.j2"] , dependencies)